/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useRef, useEffect, useState } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Link from 'next/link';

import { getObjectByLanguage } from 'language/helpers';
import maskAmount from 'utils/maskAmount';
import { MACHINE_STATE } from 'constants/common';

const MachinerySlider = ({ machines, title }) => {
  const sliderRef = useRef();

  const [minNumberOfSlidesToShow, setMinNumberOfSlidesToShow] = useState(3);
  const [slidesToShow, setSlidesToShow] = useState(machines.length < 5 ? Math.max(machines.length, minNumberOfSlidesToShow) : 5);

  useEffect(() => {
    if (window.innerWidth < 500) {
      setMinNumberOfSlidesToShow(1);
      setSlidesToShow(1);
    }
  }, []);

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoPlaySpeed: 1000,
    autoplay: false,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
  };

  const slideNext = () => {
    sliderRef.current.slickNext();
  };

  const slidePrevious = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div className="row mt-60 mb-30">
      <div className="col">
        <h2 className="h3">{title}</h2>
        <div className="im-slider-container">
          <div className="im-slider recommended-slider" data-slider-id="recommended">
            <Slider {...sliderSettings} ref={sliderRef}>
              {_.map(machines, (machine) => (
                <div key={machine.id} className="im-box im-box--white im-box--padding-0 im-box--border-radius im-box--o-hidden im-box--flex-sections">
                  <div className="im-box__header">
                    <img src={machine.coverImage || '/image/machine-detail-slider-placeholder.jpg'} alt="item" className="im-box__header__image" />
                    {machine.state === MACHINE_STATE.SOLD && (
                      <div className="image-sold-text-container">
                        <div className="image-sold-text">SATILDI</div>
                      </div>
                    )}
                    {machine.state === MACHINE_STATE.SUSPENDED && (
                      <div className="image-sold-text-container">
                        <div className="image-sold-text" style={{ transform: 'rotate(-25deg) scale(0.45)' }}>ÖDEME BEKLENİYOR</div>
                      </div>
                    )}
                  </div>
                  <div className="im-box__body">
                    <div className="fs-15 fw-500 mb-2">{getObjectByLanguage(machine.title)}</div>
                    <div>
                      <span className="fs-13 mb-3">{machine.region}</span>
                    </div>
                  </div>
                  <div className="im-box__footer">
                    <span className="fs-21 fw-900">{maskAmount(getObjectByLanguage(machine.auctionStartPrice))}</span>
                  </div>
                  <Link href="/machinery/[id]" as={`/machinery/${machine.id}`}>
                    <a className="im-box__link im-box__link--transparent" />
                  </Link>
                </div>
              ))}

              {
                // Add empty slides if there are too few machines, so that real slides won't be too wide
                machines.length < minNumberOfSlidesToShow
                  ? [...Array(minNumberOfSlidesToShow - machines.length).keys()].map((i) => (<div key={i} />))
                  : undefined
              }
            </Slider>
          </div>
          <div className="im-slider__arrows im-slider__arrows--type2">
            <div className="im-slider__arrows__prev" onClick={() => slidePrevious()}>
              <i className="fa-solid fa-angle-left" />
            </div>
            <div className="im-slider__arrows__next" onClick={() => slideNext()}>
              <i className="fa-solid fa-angle-right" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MachinerySlider.propTypes = {
  machines: PropTypes.array,
  title: PropTypes.string,
};

export default MachinerySlider;
